/**
 * @license Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md.
 */

import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import LinklawCommand from './linklawcommand';

export default class LinklawEditing extends Plugin {
	init() {
		this._defineSchema();
		this._defineConverters();

		this.editor.commands.add(
			'addLinklaw', new LinklawCommand( this.editor )
		);
	}

	_defineSchema() {
		const schema = this.editor.model.schema;

    	// Extend the text node's schema to accept the linklaw attribute.
		schema.extend( '$text', {
			allowAttributes: [ 'linklaw', 'articlelaw', 'tooltip', 'id' ]
		} );
	}
	_defineConverters() {
		const conversion = this.editor.conversion;
		
        // Conversion from a model attribute to a view element
		conversion.for( 'downcast' ).attributeToElement( {
			model: 'linklaw', 

            // Callback function provides access to the model attribute value
			// and the DowncastWriter
			view: ( modelAttributeValue, conversionApi ) => {
				const { writer } = conversionApi;
				return writer.createAttributeElement( 'span', {
					'data-linklaw': modelAttributeValue
				} );
			},
			
		} );

		conversion.for( 'downcast' ).attributeToElement( {
			model: 'articlelaw',

            // Callback function provides access to the model attribute value
			// and the DowncastWriter
			view: ( modelAttributeValue, conversionApi ) => {
				const { writer } = conversionApi;
				return writer.createAttributeElement( 'span', {
					'data-articlelaw': modelAttributeValue
				} );
			}
		} );

		conversion.for( 'downcast' ).attributeToElement( {
			model: 'tooltip',

            // Callback function provides access to the model attribute value
			// and the DowncastWriter
			view: ( modelAttributeValue, conversionApi ) => {
				const { writer } = conversionApi;
				return writer.createAttributeElement( 'span', {
					'data-cke-tooltip-text': modelAttributeValue
				} );
			}
		} );

		conversion.for( 'downcast' ).attributeToElement( {
			model: 'id',

            // Callback function provides access to the model attribute value
			// and the DowncastWriter
			view: ( modelAttributeValue, conversionApi ) => {
				const { writer } = conversionApi;
				return writer.createAttributeElement( 'span', {
					'data-id': modelAttributeValue
				} );
			}
		} );

		// Conversion from a view element to a model attribute
		conversion.for( 'upcast' ).elementToAttribute( {
			view: {
				name: 'span',
				attributes: [ 'data-linklaw' ]
			},
			model: {
				key: 'linklaw',

                // Callback function provides access to the view element
				value: viewElement => {
					const dataLinklaw = viewElement.getAttribute( 'data-linklaw' );
					return dataLinklaw;
				}
			}
		} );

		conversion.for( 'upcast' ).elementToAttribute( {
			view: {
				name: 'span',
				attributes: [ 'data-articlelaw' ]
			},
			model: {
				key: 'articlelaw',

                // Callback function provides access to the view element
				value: viewElement => {
					const dataArticlelaw = viewElement.getAttribute( 'data-articlelaw' );
					return dataArticlelaw;
				}
			}
		} );

		conversion.for( 'upcast' ).elementToAttribute( {
			view: {
				name: 'span',
				attributes: [ 'data-cke-tooltip-text' ]
			},
			model: {
				key: 'tooltip',

                // Callback function provides access to the view element
				value: viewElement => {
					const dataLinklaw = viewElement.getAttribute( 'data-cke-tooltip-text' );
					return dataLinklaw;
				}
			}
		} );

		conversion.for( 'upcast' ).elementToAttribute( {
			view: {
				name: 'span',
				attributes: [ 'data-id' ]
			},
			model: {
				key: 'id',

                // Callback function provides access to the view element
				value: viewElement => {
					const dataId = viewElement.getAttribute( 'data-id' );
					return dataId;
				}
			}
		} );

	}
}